import { motion } from "framer-motion";
interface SectionHeaderProps {
  badge?: string;
  title: string;
  highlightedWord?: string;
  highlightColor?: "accent" | "accent-purple";
  description?: string;
  className?: string;
  centered?: boolean;
}
const SectionHeader = ({
  badge,
  title,
  highlightedWord,
  highlightColor = "accent",
  description,
  className = "",
  centered = true
}: SectionHeaderProps) => {
  // Split title to find and highlight the specified word
  const renderTitle = () => {
    if (!highlightedWord) {
      return <span>{title}</span>;
    }
    const parts = title.split(new RegExp(`(${highlightedWord})`, 'gi'));
    return parts.map((part, index) => {
      if (part.toLowerCase() === highlightedWord.toLowerCase()) {
        return <span key={index} className={`font-serif italic ${highlightColor === "accent-purple" ? "text-accent-purple" : "text-accent"}`}>
            {part}
          </span>;
      }
      return <span key={index}>{part}</span>;
    });
  };
  return <div className={`${centered ? 'text-center' : ''} ${className}`}>
      {badge && <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="inline-block mb-4 md:mb-6">
          <span className="inline-block px-4 py-2 bg-foreground/10 border border-foreground/20 rounded-full text-foreground/80 font-medium text-xs md:text-sm">
            {badge}
          </span>
        </motion.div>}
      
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-normal mb-4 md:mb-6 tracking-tight">
        {renderTitle()}
      </motion.h2>

      {description && <motion.p initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="text-base md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          {description}
        </motion.p>}
    </div>;
};
export default SectionHeader;